import type { ToolContent } from "@/types/tools";
import Image from "next/image";
import { CDN_URL } from "@/consts";

interface VideoCompressorProps {
  content: ToolContent;
}

const VideoCompressor = ({ content }: VideoCompressorProps) => {
  return (
    <Image
      src={`${CDN_URL}/features/free/video-compressor/hero-component.png`}
      alt="Video Compressor"
      width={660}
      height={260}
      draggable={false}
      className="h-auto max-w-[268px] select-none md:max-w-[330px]"
    />
  );
};

export default VideoCompressor;
